
















import { Component, Vue } from "vue-property-decorator";

@Component
export default class Programme extends Vue {
  get content() {
    return this.$store.getters.getProgrammeContent;
  }
  get loaded() {
    return typeof this.content != "undefined";
  }
}
